module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/global/logo.svg")
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [_c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      success: _vm.isSuccess, error: _vm.hasError
    },
    attrs: {
      "type": "password",
      "pattern": ".{6,}",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.confirmPassword),
      expression: "confirmPassword",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      success: _vm.isSuccess, error: _vm.hasError
    },
    attrs: {
      "type": "password",
      "pattern": ".{6,}",
      "placeholder": "Confirm Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "type": "submit",
      "value": "Set Password"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "feedback"
  }, [_vm._v(_vm._s(_vm.message))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link navy",
    attrs: {
      "to": "terms"
    }
  }, [_vm._v("Terms & Conditions")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("Great, let's keep your")]), _vm._v(" account safe")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e73937"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-2.vue
// module id = 686
// module chunks = 1